import { render, staticRenderFns } from "./BaseTabBar.vue?vue&type=template&id=683e7f00&"
import script from "./BaseTabBar.vue?vue&type=script&lang=js&"
export * from "./BaseTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports